import { InputControl } from "./input-control";
export class TimeInputControl extends InputControl {
    get format() {
        let format = this.controlOpts.format;
        if (!format) {
            return "HH:mm:ss";
        }
        return format;
    }
    get timeCtrl() {
        return this.ctrl;
    }
}
